import { useNavigate } from 'react-router-dom';

import { ScheduleTemplateResp } from '@api/responseModels/worker/schedule/scheduleTemplateResponse';
import { CRMAPIManager } from '@classes/crmApiManager';

import { TScheduleTemplatePanelState, TState } from '../schedule';

export function useUpdateScheduleFromTemplate({
    crmID,
    getStartDate,
    state,
    stpState,
    workerPositionID,
    messageApi,
}: {
    state: TState;
    crmID: string | number;
    workerPositionID: string | number;
    stpState: TScheduleTemplatePanelState;
    getStartDate: (schedule: any) => string;
    messageApi: any;
}) {
    const navigate = useNavigate();

    const updateScheduleFromTemplate = async () => {
        state.isLoading = true;
        const temp = state.scheduleTemplates.find((t) => t.id === stpState.selectedTemplateId);
        if (!temp) return;

        try {
            const result = await CRMAPIManager.request<ScheduleTemplateResp>(async (api) => {
                return await api.updateSchedule(+crmID, state.scheduleOrigin.id, {
                    title:
                        stpState.activeTemplateNameMirror.trim() === ''
                            ? temp.title
                            : stpState.activeTemplateNameMirror,
                    start_time: temp.start_time,
                    end_time: temp.end_time,
                    breaks: temp.breaks,
                    day_offs: temp.day_offs,
                    schedule_days: temp.schedule_days ?? [],
                    schedule_type: temp.schedule_type,
                    exception_days: temp.exception_days,
                    start_schedule_at: getStartDate(state.scheduleOrigin),
                });
            });

            if (result.errorCode) throw result;

            messageApi.success('График обновлён');
            stpState.selectedTemplateId = null;
            navigate(`/lk/worker/crm/${crmID}/workers/${workerPositionID}/schedule`);
        } catch (err) {
            messageApi.error('Ошибка при обновлении графика');
            console.log(err);
        }

        state.isLoading = false;
    };

    return { updateScheduleFromTemplate };
}
